import api from '../../plugins/api';

const setStep = (payload) => {
  return api.post('/api/crm/deals/setStep', payload);
};

export default setStep;
